import { Button, Col, Form, Input, Modal, Row, Select } from 'antd';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { loadSingleStaff, EmployeeBankDetailsSetup } from '../../../redux/rtk/features/user/userSlice';
import getUserFromToken from '../../../utils/getUserFromToken';
import BtnEditSvg from '../Button/btnEditSvg';
import { getAllMaster } from '../../../redux/rtk/features/masters/masterSlice';

const BankDetailPopup = ({ data }) => {
  // console.log("data", data);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [activeData, setActiveData] = useState([]); // Define activeData as state
  const dispatch = useDispatch();
  const { Option } = Select;
  const [form] = Form.useForm();
  const loggedInUserId = getUserFromToken();
  const { id } = useParams();
  // Staff detail page :id is the employee being edited (admin can edit other employees)
  const employeeId = Number(id) || Number(activeData?.[0]?.EmployeeId) || 0;
  const masterData = useSelector((state) => state.masters.masters);

  useEffect(() => {
    dispatch(getAllMaster());
  }, [dispatch]);

  useEffect(() => {
    // Filter data for records with DataStatus: 1
    const filteredData = Array.isArray(data) ? data.filter(item => item.DataStatus === 1) : [];
    setActiveData(filteredData); // Update state with filtered data

    // If there's at least one record with DataStatus: 1, prefill the form with the first one
    if (filteredData.length > 0) {
      const firstActiveRecord = filteredData[0];
      const branchName = firstActiveRecord.BranchName;
      form.setFieldsValue({
        AccountHolderName: firstActiveRecord.AccountHolderName || '',
        BranchName: Array.isArray(branchName) ? branchName[0] || '' : branchName || '',
        AccountNumber: firstActiveRecord.AccountNumber || '',
        IfscCode: firstActiveRecord.IfscCode || '',
        BankTypeId: firstActiveRecord.BankTypeId || 1,
        AccountTypeId: firstActiveRecord.AccountTypeId || 1,
        UpiId: firstActiveRecord.UpiId || '',
      });
    }
  }, [data, form]);

  const onFinish = async (values) => {
    if (!employeeId) {
      toast.error("Employee ID is missing. Please open the employee profile again.");
      return;
    }

    const payload = {
      BankId: activeData.length > 0 ? activeData[0].BankId : 0, // Use BankId from state
      EmployeeId: employeeId,
      BankTypeId: values.BankTypeId || 1,
      BranchName: values.BranchName,
      IfscCode: values.IfscCode,
      MicrCode: values.MicrCode || "Beyond Imagination",
      BankAddress: values.BankAddress || "Beyond Imagination",
      PanNumber: values.PanNumber || "Beyond Imagination",
      UpiId: values.UpiId || "Beyond Imagination",
      AccountHolderName: values.AccountHolderName,
      AccountNumber: values.AccountNumber,
      AccountTypeId: values.AccountTypeId || 1,
      OpeningBalance: values.OpeningBalance || 0,
      DataStatus: 1,
      CreatedBy: String(loggedInUserId ?? "0"),
      ModifiedBy: String(loggedInUserId ?? "0"),
    };

    try {
      await dispatch(EmployeeBankDetailsSetup(payload));
      dispatch(loadSingleStaff(employeeId));
      setIsModalOpen(false);
    } catch (error) {
      // console.error('Error saving bank details:', error);
    }
  };

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <button onClick={showModal}>
        <BtnEditSvg size={30} />
      </button>
      <Modal
        width="50%"
        title={activeData.length > 0 ? "Update Bank Details" : "Add Bank Details"} // Use activeData from state
        open={isModalOpen}
        onCancel={handleCancel}
        footer={null}
      >
        <Form
          form={form}
          onFinish={onFinish}
          layout="vertical"
          autoComplete="off"
        >
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                label="Account Holder Name"
                name="AccountHolderName"
                rules={[{ required: true, message: 'Please input the account holder name!' }]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="Bank Type"
                name="BankTypeId"
                rules={[{ required: true, message: 'Please select the bank type!' }]}
                initialValue={1}
              >
                <Select
                  className="w-full rounded-lg border-gray-300 focus:border-blue-500 text-sm"
                  placeholder="Select Bank"
                >
                  {masterData?.BankTypeMaster?.filter(
                    (bank) => bank.DataStatus === 1
                  ).map((bank) => (
                    <Option
                      key={bank.BankTypeId}
                      value={bank.BankTypeId}
                    >
                      {bank.BankTypeName}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                label="Account Number"
                name="AccountNumber"
                rules={[{ required: true, message: 'Please input the account number!' }]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="IFSC Code"
                name="IfscCode"
                rules={[{ required: true, message: 'Please input the IFSC code!' }]}
              >
                <Input />
              </Form.Item>
            </Col>
          </Row>
          <Form.Item
            label="Branch Name"
            name="BranchName"
            rules={[{ required: true, message: 'Please input the branch name!' }]}
          >
            <Input />
          </Form.Item>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                label="Account Type"
                name="AccountTypeId"
                rules={[{ required: true, message: 'Please select the account type!' }]}
                initialValue={1}
              >
                <Select>
                  <Option value={1}>Savings</Option>
                  <Option value={2}>Current</Option>
                </Select>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="UPI ID"
                name="UpiId"
              >
                <Input />
              </Form.Item>
            </Col>
          </Row>
          <Form.Item>
            <Button type="primary" htmlType="submit">
              {activeData.length > 0 ? "Update" : "Add"} Bank Details
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default BankDetailPopup;